// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/seed-product-selector/product-inputs/';
export const actions = [
  'SET_SEED_SELECTOR_PRODUCT_INPUT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer
export default function reducer(
  state = {
    seed: {}
  },
  action = {}
) {

  switch (action.type) {
    case actions.SET_SEED_SELECTOR_PRODUCT_INPUT:
      return {
        ...state,
        [action.payload.applicationType]: {
          ...state[action.payload.applicationType],
          [action.payload.selectId]: { currentProductId: action.payload.currentProductId }
        }
      };

    default:
      return state;
  }
}

// Action creators

export const setSeedSelectorProductInput = ({ currentProductId, selectId }) => {
  return {
    type: actions.SET_SEED_SELECTOR_PRODUCT_INPUT,
    payload: { applicationType: 'seed', currentProductId, selectId }
  };
};
